import { render, staticRenderFns } from "./WishlistComponent.vue?vue&type=template&id=d3c85ab4&scoped=true&"
import script from "./WishlistComponent.vue?vue&type=script&lang=js&"
export * from "./WishlistComponent.vue?vue&type=script&lang=js&"
import style0 from "./WishlistComponent.vue?vue&type=style&index=0&id=d3c85ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c85ab4",
  null
  
)

export default component.exports